<!--
 * @Author: your name
 * @Date: 2021-03-04 16:20:57
 * @LastEditTime: 2024-03-02 14:42:06
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\basics\Pagination.vue
-->
<template>
  <div class="pagination">
    <!-- <template v-if="current<12"> -->
    <el-pagination background :hide-on-single-page="current<=12" :total="current" :current-page="page" :page-size="limit" layout="prev, pager, next" @current-change="currentChange" :pager-count="pagerCount"></el-pagination>
    <!-- </template> -->
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    current: {
      type: Number,
      default: 0,
      required: true
    },
    limit: {
      type: Number,
      default: 12
    },
    page: {
      type: Number,
      default: 1
    },
    pagerCount: {
      type: Number,
      default: 7
    }
  },
  methods: {
    currentChange(val) {
      this.$emit("currentChange", val);
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  /deep/ .el-pager li {
    background-color: #edfbff;
  }

  /deep/ .el-pager li:not(.disabled).active {
    background-color: #2fb3ff;
  }
}
</style>
